import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import InputText from "../InputText/InputText";

/**
 * LinkButton component - A text input with an "Open Link" button
 * The text input is only editable by admin users
 */
const LinkButton = ({
    label,
    name,
    defaultValue,
    handleChange,
    formType,
    currentRole,
    disabled,
    err,
}) => {
    const handleOpenLink = () => {
        if (defaultValue && defaultValue.trim() !== "") {
            // Ensure the URL has a protocol
            let url = defaultValue.trim();
            if (!url.startsWith("http://") && !url.startsWith("https://")) {
                url = "https://" + url;
            }
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    const isLinkEmpty = !defaultValue || defaultValue.trim() === "";

    return (
        <div className="flex flex-col gap-2">
            <InputText
                label={label}
                type="text"
                name={name}
                err={err}
                handleChange={handleChange}
                defaultValue={defaultValue}
                disabled={disabled}
                disableEditForNonAdmin={true}
                formType={formType}
                currentRole={currentRole}
                placeholder="Enter documentation URL..."
            />
            <button
                type="button"
                onClick={handleOpenLink}
                disabled={isLinkEmpty}
                className={`inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors ${isLinkEmpty
                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : "bg-primary text-white hover:bg-purple-700 cursor-pointer"
                    }`}
            >
                <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                Open Link
            </button>
        </div>
    );
};

export default LinkButton;
